import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField, Button, Box, Snackbar } from "@mui/material";
import PropTypes from "prop-types";
import { fieldUser } from "./FieldJson.js";
import { Validation } from "../../../Validation/Validation.js";
import {
  UpdateUserProfile,
  ResetProfileState,
} from "../../../Actions/MyProfileActions.js";
import "../profile.scss";
import "../../../assets/styles/form.scss";
import "../../../assets/styles/glButton.scss";

const UserDtails = ({ editData }) => {
  const [formData, setFormData] = useState({
    userName: "",
    accountType: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const [formError, setFormError] = useState({});
  const [message, setMessage] = useState("");
  const [classForToast, setClassForToast] = useState("");
  const [open, setOpen] = useState(false);
  const [disblebtn, setDisblebtn] = useState(false)
  const enableSnackbar = useSelector((state) => state.snackbar.enableSnackbar);
  const testModeEnabled = useSelector(
    (state) => state.snackbar.testModeEnabled
  );
  const { updateLoading, updateError, updateSuccess } = useSelector(
    (state) => state.profile
  );
  const dispatch = useDispatch();

  useEffect(
    () => () => {
      dispatch(ResetProfileState());
    },
    [dispatch]
  );

  useEffect(() => {
    if (updateError) {
      setMessage(updateError);
      setClassForToast("error");
      setOpen(true);
    } else if (updateSuccess) {
      setMessage("Profile has been updated.");
      setClassForToast("success");
      setOpen(true);
    }
  }, [updateSuccess, updateError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDisblebtn(true)
    if (name === "phoneNumber") {
      const cleaned = value.replace(/[^\d+\-()\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleaned }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleValidation = () => {
    let isValid = true;
    let errors = {};
    fieldUser.forEach((field) => {
      if (Validation.empty(formData[field.name]) && !field.disabled) {
        isValid = false;
        errors[field.name] = `Please enter ${field.errorMessage || field.name}`;
      } else if (field.name === "phoneNumber") {
        const phone = formData[field.name];
        if (phone && !/^\d{10}$/.test(phone)) {
          isValid = false;
          if (phone.length > 10) {
            errors[field.name] = "Phone number should not exceed 10 digits";
          } else if (phone.length < 10) {
            errors[field.name] = "Phone number should be at least 10 digits";
          } else {
            errors[field.name] = "Please enter a valid 10-digit phone number";
          }
        }
      }
    });

    setFormError(isValid ? {} : errors);
    return isValid;
  };
  const handleEdit = (e) => {
    e.preventDefault();
    if (!handleValidation()) return;

    dispatch(UpdateUserProfile(formData, editData));
  };

  const handleRolesValues = (rolesValues) => {
    switch (rolesValues) {
      case "SUPER_ADMIN":
        return "Admin";
      case "MODERATOR":
        return "Viewer";
      case "BUILDING_ADMIN":
        return "Building Admin";
      case "BUILDING_MODERATOR":
        return "Building Viewer";
      default:
        return "";
    }
  };

  const handleCloseToast = () => {
    setOpen(false);
    setMessage("");
    setClassForToast("");
  };
  useEffect(() =>{
     setTimeout(() =>{
      document.getElementById('tab-profile')?.focus()
    },200)
  },[classForToast  ])
  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      setFormData({
        userName: editData.email || "",
        accountType: handleRolesValues(editData.roleId || ""),
        firstName: editData.firstName || "",
        lastName: editData.lastName || "",
        phoneNumber: editData.telephone || "",
        email: editData.email || "",
      });
    }
  }, [editData]);
  return (
    <div className="globalForm profileUserForm">
      <div className="mainModalBox">
        <div className="Modal_middle">
          <h2 id="edit-device-heading">User Details</h2>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            className="field_addDevice"
            aria-describedby="form-description"
            aria-labelledby="edit-device-heading"
          >
            <p id="form-description" className="visually-hidden">
              Fill out the fields below to update device details. Required
              fields are marked.
            </p>
            {fieldUser.map((field) => {
              const error = !!formError[field.name];
              const fieldId = `field-${field.name}`;
              const helperId = `helper-${field.name}`;
              return (
                <TextField
                  key={fieldId}
                  id={fieldId}
                  name={field.name}
                  label={field.label}
                  variant="outlined"
                  disabled={field.disabled}
                  onChange={handleInputChange}
                  value={
                    formData[field.name] === "string"
                      ? ""
                      : formData[field.name] || ""
                  }
                  error={error}
                  aria-invalid={error}
                  aria-describedby={helperId}
                    helperText={
                    formError[field.name] ? (
                      <span id={helperId} role="alert">
                        {formError[field.name]}
                      </span>
                    ) : (
                      <span id={helperId}>{field.helperText}</span>
                    )
                  }
                  className="innerFields"
                  fullWidth
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                      style: { transform: "inherit" },
                    },
                  }}
                  required={!field.disabled}
                   inputProps={{
                    inputMode: field.name === "phoneNumber" ? "tel" : undefined,
                  }}
                />
              );
            })}

            <div
              className="Modal_footer adddeviceFooter"
              style={{ width: "100%" }}
            >
              <Box sx={{ display: "flex" }}>
                <button
                  className="containedButton "
                  onClick={handleEdit}
                  disabled={updateLoading || !disblebtn}
                  aria-label="Save"
                  disableRipple
                >
                  {updateLoading ? "Saving..." : "Save"}
                </button>
                <Snackbar
                  open={open}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  className={classForToast === "error" ? "error" : "success"}
                  autoHideDuration={5000}
                  sx={{
                    pointerEvents: "none",
                    ...((enableSnackbar || testModeEnabled) && {
                      paddingTop: "45px",
                    }),
                  }}
                  message={message}
                  onClose={handleCloseToast}
                  aria-live="polite"
                />
              </Box>
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
};

UserDtails.propTypes = {
  editData: PropTypes.shape({
    email: PropTypes.string,
    roleId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    telephone: PropTypes.string,
    tenantId: PropTypes.string,
    note: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};

export default UserDtails;
